import StartProfileCreation from "./StartProfileCreation";

export default function ProfileCreateFlow() {
  return <StartProfileCreation />;
}
